import React, { useEffect, useState, useContext } from 'react';
import TextTitle from '../../../../components/TextTitle/TextTitle';
import FieldText from '../../../../components/FieldText/FieldText';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import FieldNumber from '../../../../components/FieldNumber/FieldNumber';
import PageTitleMid from '../../../../components/PageTitleMid/PageTitleMid';
import { API } from '../../../../API/API';
import { UserContext } from '../../../../context/UserContext';
import Warning from '../../../../components/Warning/Warning';
import { MessageConst } from '../../../../const/MessageConst';
import { message } from 'antd';
import GridAdd from '../../../../components/GridAdd/GridAdd';
import MaritalStatus from './New/MaritalStatus';
import { Color, constData } from '../../../../const/Const';
import { hideLoadScreen, showLoadScreen } from '../../../../components/LoadScreen/LoadScreen';
import { Row, Col } from 'antd';
import ButtonDefaultWithLoad from '../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import LoadSpin from '../../../../components/LoadSpin/LoadSpin';

const Basic = (props) => {

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [empid, setEmpId] = useState(-1);
    const { userInfo } = useContext(UserContext);
    const [initData] = useState({
        "empid": -1,
        "regno": null,
        "civilid": null,
        "familyname": null,
        "birthdate": null,
        "birthdistrictid": null,
        "isforeigner": false,
        "districtid": null,
        "lastname": null,
        "gender": null,
        "birthcountryid": null,
        "birthplace": null,
        "countryid": null,
        "nationalityid": null,
        "firstname": null,
        "maritalstatus": null,
        "birthdivisionid": null,
        "divisionid": null,
        "socialoriginid": null,
        "companyid": userInfo?.companyid?.toUpperCase(),
        "mobilephone": null,
        "workphoneext": null,
        "email": null,
        "linkedin": null,
        "addr1": null,
        "homephone": null,
        "fax": null,
        "email2": null,
        "facebook": null,
        "addr2": null,
        "workphone": null,
        "postaddress": null,
        "twitter": null
    });

    const [data, setData] = useState({ ...initData });
    const [dataMaritalStatus, setDataMaritalStatus] = useState([]);
    const [dGender] = useState(constData.Gender);
    const [warning, setWarning] = useState();

    const [onOpenMS, setOnOpenMS] = useState(false);
    const [entryid, setEntryId] = useState();

    const [loadingSave, setLoadingSave] = useState(false);
    const [mode, setMode] = useState(false);

    const [isPressSave, setIsPressSave] = useState(false);
    const [colSpan] = useState(window.innerWidth > 1000 ? 8 : 24);
    const [loadingReg, setloadingReg] = useState(false);

    useEffect(() => {
        let tEmpId = -1;
        if (params.empid) {
            tEmpId = params.empid;
        }
        setEmpId(tEmpId);
    }, [params]);

    const getExistsData = async () => {
        let tInitData = { ...initData };
        setMode(false);
        let tData = { ...tInitData };

        if (empid > 0) {

            await API.get('/api/humanresource/employee/get_employee?empid=' + empid).then(response => {
                if (response.status == 200 && response.data?.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
        }

        setData(tData);
        setIsPressSave(false);
        setWarning();
        await getDataMaritalStatus();
    }

    const getDataMaritalStatus = async () => {
        let tDataMaritalStatus = [];

        if (empid > 0) {
            await API.get('/api/humanresource/employee/get_empfamily_list?empid=' + empid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    tDataMaritalStatus = response.data.retdata;
                }
            });
        }

        setDataMaritalStatus(tDataMaritalStatus);
    }

    const getAllData = async () => {
        showLoadScreen();
        await getExistsData();
        hideLoadScreen();
    }

    useEffect(() => {
        getAllData();
    }, [empid, location?.state]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'birthcountryid') {
                tData.birthdivisionid = null;
                tData.birthdistrictid = null;
            }

            if (field == 'birthdivisionid') {
                tData.birthdistrictid = null;
            }

            if (field == 'regno' && key?.length == 10) {
                setloadingReg(true);
                await API.get('/api/humanresource/employee/get_find_emp_info_from_regno?regno=' + key).then(response => {
                    if (response.status == 200 && response.data?.rettype == 0) {
                        if (response.data?.retdata?.valid == 1) {
                            tData = { ...tData, ...response.data.retdata };
                        }
                    }
                }).catch(response => {
                    setloadingReg(false);
                });
                setloadingReg(false);
            }

            setData(tData);
            setMode(true);
        }
    }

    const onSave = async () => {
        let isValid = true;

        setIsPressSave(true);

        if (!data.regno) {
            isValid = false;
            setWarning("Регистрийн дугаар" + MessageConst.fieldRequired);
        } else if (!data.lastname) {
            isValid = false;
            setWarning("Эцэг/эх-ийн нэр" + MessageConst.fieldRequired);
        } else if (!data.firstname) {
            isValid = false;
            setWarning("Нэр" + MessageConst.fieldRequired);
        } else if (!data.gender) {
            isValid = false;
            setWarning("Хүйс" + MessageConst.fieldRequired);
        } else if (!data.birthdate) {
            isValid = false;
            setWarning("Төрсөн огноо" + MessageConst.fieldRequired);
        } else if (data.civilid) {
            if (data.civilid.length < 12 ||
                (data.civilid.length == 12 && !/^\d+$/.test(data.civilid))) {
                isValid = false;
                setWarning("Иргэний бүртгэлийн дугаарын формат буруу байна. 12 оронтой тоо эсвэл 13 оронтой том үсэг, тоо холилдсон тэмдэгт оруулна уу");
            }
        }

        if (isValid) {

            setLoadingSave(true);
            await API.post('/api/humanresource/employee/save_employee', [data]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        message.success(MessageConst.success);
                        setMode(false);
                        setWarning();
                        setIsPressSave(false);

                        if (empid <= 0) {
                            let nempid = response.data.retdata[0]?.newid;
                            setData({ ...initData });
                            navigate('/hrsuite/employee/' + nempid + '?tab=basic', {
                                state: {
                                    backurl: true
                                }
                            });

                        }
                    }
                }
            });
            setLoadingSave(false);
        }
    }

    const afterSaveMaritalStatus = async (p_close) => {
        if (p_close) {
            setOnOpenMS(false);
        }
        showLoadScreen();
        await getDataMaritalStatus();
        hideLoadScreen();
    }


    const onDismissMS = () => {
        setEntryId(-1);
        setOnOpenMS(false);
    }


    const onEditMS = (p_entryid) => {
        setEntryId(p_entryid);
        setOnOpenMS(true);
    }

    const onNewMS = () => { setOnOpenMS(true); setEntryId(-1); }

    return (
        <div style={{ padding: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <TextTitle title="Хувь хүний талаарх мэдээлэл" />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <Warning zeroMargin value={warning} />
                    </div>
                    {mode && (
                        <div style={{ marginLeft: 16 }}>
                            <ButtonDefaultWithLoad loading={loadingSave} onClick={onSave} text="Хадгалах" />
                        </div>
                    )}
                </div>
            </div>
            <div style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <div>
                    <PageTitleMid>Үндсэн</PageTitleMid>
                </div>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan / 2}>
                        <FieldText required title="Регистрийн дугаар" onChanged={fieldOnChanged} keyfield='regno' defaultValue={data.regno} checkreq={isPressSave} />
                    </Col>
                    <Col span={colSpan / 2}>
                        <FieldText title="Иргэний бүртгэлийн дугаар" maxLength={13} onChanged={fieldOnChanged} keyfield='civilid' defaultValue={data.civilid} checkreq={isPressSave} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldText required title="Нэр" onChanged={fieldOnChanged} keyfield='firstname' defaultValue={data.firstname} checkreq={isPressSave} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldText required title="Эцэг/эх-ийн нэр" onChanged={fieldOnChanged} keyfield='lastname' defaultValue={data.lastname} checkreq={isPressSave} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldText title="Ургийн овог" onChanged={fieldOnChanged} keyfield='familyname' defaultValue={data.familyname} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldDropdown required title="Хүйс" onChanged={fieldOnChanged} keyfield='gender' defaultValue={data.gender} data={dGender} checkreq={isPressSave} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldDate required title="Төрсөн огноо" onChanged={fieldOnChanged} keyfield='birthdate' defaultValue={data.birthdate} checkreq={isPressSave} />
                    </Col>
                </Row>
                {empid > 0 && (
                    <div>
                        <div style={{ marginTop: 24 }}>
                            <GridAdd
                                title="Гэр бүлийн байдал"
                                description="Зөвхөн гэр бүлийн бүртгэлд байгаа хүмүүс"
                                onNew={onNewMS}
                                data={dataMaritalStatus}
                                columns={[{
                                    name: 'Хэн болох',
                                    fieldName: 'relativename',
                                    maxWidth: 200,
                                    minWidth: 80,
                                    onRender: (item) => {
                                        return (
                                            <div
                                                onClick={() => onEditMS(item.entryid)}
                                                style={{ color: Color.blue, cursor: 'pointer' }}
                                            >
                                                {item.relativename}
                                            </div>
                                        );
                                    }
                                }, {
                                    name: 'Эцэг/эх/-ийн нэр',
                                    fieldName: 'lastname',
                                    maxWidth: 300,
                                    minWidth: 80
                                }, {
                                    name: 'Нэр',
                                    fieldName: 'firstname',
                                    maxWidth: 300,
                                    minWidth: 80
                                }, {
                                    name: 'Регистрийн дугаар',
                                    fieldName: 'famregno'
                                }]}
                            />
                            <MaritalStatus
                                entryid={entryid}
                                empid={empid}
                                onOpen={onOpenMS}
                                onDismiss={onDismissMS}
                                afterSave={afterSaveMaritalStatus} />
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <PageTitleMid>Холбоо барих</PageTitleMid>
                        </div>
                        <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                            <Col span={colSpan}>
                                <FieldNumber title="Гар утас" onChanged={fieldOnChanged} keyfield='mobilephone' defaultValue={data.mobilephone} />
                            </Col>
                            <Col span={colSpan}>
                                <FieldNumber title="Утас (гэр)" onChanged={fieldOnChanged} keyfield='homephone' defaultValue={data.homephone} />
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                            <Col span={colSpan}>
                                <FieldText title="И-мэйл (албан)" onChanged={fieldOnChanged} keyfield='email' defaultValue={data.email} />
                            </Col>
                            <Col span={colSpan}>
                                <FieldText title="И-мэйл (хувийн)" onChanged={fieldOnChanged} keyfield='email2' defaultValue={data.email2} />
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Basic;